import i18next from "i18next";
import i18nBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Optional: Language mapping
const lanMap = {
  eng: "en",
  ara: "ar",
  tha: "th",
  spa: "es",
  ben: "bn",
  guj: "gu",
  hin: "hi",
  mar: "mr",
  tam: "ta",
  tel: "te",
  gre: "el",
  rom: "ro",
  por: "pt",
  sin: "si",
  amh: "am",
  fre: "fr",
  swa: "sw",
  tur: "tr",
  khm: "km",
  bur: "my",
  vie: "vi",
  urd: "ur",
};

export const getMappedLanCode = async (code) => {
  return lanMap[code] || "en";
};

// 🔥 Hardcoded path — directly pointing to `om/production`
const languageBaseURL = "https://storage.googleapis.com/gamerji-uploads/languages/om/production/";

i18next
  .use(i18nBackend)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "cookie", "path"],
      caches: ["cookie"],
    },
    backend: {
      loadPath: `${languageBaseURL}{{lng}}.json`, // ✅ Hardcoded
    },
  });

export default i18next;
